import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as stockActions from "../../../../actions/stockActions";
import * as keyboardActions from "../../../../actions/virtualKeyboardActions";
import * as barcodeActions from "../../../../actions/barcodeActions";
import * as settingsActions from "../../../../actions/settingsActions";

import StockModalComponent from "../../../../components/apps/gamma/machine/modal/StockModal";

class StockModal extends Component {
    componentDidMount = () => {
        this.props.dispatchGetAllColorantPackagesAction();
    };

    closeModal = () => {
        this.props.dispatchResetAllColorantPackagesAction();
        this.props.dispatchCloseStockModalAction();
    };

    render() {
        return (
            <StockModalComponent
                tabId={this.props.tabId}
                loggedUser={this.props.loggedUser}
                cart={this.props.cart}
                closeModal={this.closeModal}
                colorantPackages={this.props.colorantPackages}
                databases={this.props.databases}
                stockDatabaseFilter={this.props.stockDatabaseFilter}
                stockTableOrderBy={this.props.stockTableOrderBy}
                setUniversalKeyboardState={this.props.dispatchSetUniversalKeyboardStateAction}
                setStockDatabaseFilter={this.props.dispatchSetStockDatabaseFilterAction}
                setStockTableOrderBy={this.props.dispatchSetStockTableOrderByAction}
                openAddColorantPackagesToStockModal={this.props.dispatchOpenAddColorantPackagesToStockModalAction}
                openColorantPackagesConfirmOrderStockModal={
                    this.props.dispatchOpenColorantPackagesConfirmOrderStockModalAction
                }
                openShowBarcodeModal={this.props.dispatchOpenShowBarcodeModalAction}
                openEditColorantPackageInStockModal={this.props.dispatchOpenEditColorantPackageInStockModalAction}
                resetCart={this.props.dispatchResetStockCartAction}
                saveCart={this.props.dispatchSaveStockCartAction}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        colorantPackages: store.stock.colorantPackages,
        stockTableOrderBy: store.settings.stockTableOrderBy,
        cart: store.stock.cart,
        databases: store.stock.databases,
        stockDatabaseFilter: store.settings.stockDatabaseFilter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseStockModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.STOCK_MODAL));
        },
        dispatchGetAllColorantPackagesAction: () => {
            dispatch(stockActions.getColorantPackages());
        },
        dispatchResetAllColorantPackagesAction: (canisterIndex) => {
            dispatch(stockActions.resetAllColorantPackages(canisterIndex));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(keyboardActions.setUniversalKeyboardState(state, selector));
        },
        dispatchOpenAddColorantPackagesToStockModalAction: (selectedColorantPackageKey = "") => {
            dispatch(
                navigationActions.openModalWithParams(0, componentTypes.ADD_COLORANT_PACKAGES_TO_STOCK_MODAL, {
                    selectedColorantPackageKey: selectedColorantPackageKey,
                    addColorantPackagesToStock: (colorantPackages) => {
                        dispatch(stockActions.addColorantPackages(colorantPackages));
                    }
                })
            );
        },
        dispatchOpenShowBarcodeModalAction: (colorant, pckg) => {
            dispatch(barcodeActions.getColorantPackageBarcodeAndOpenModal(colorant, pckg));
        },
        dispatchSetStockDatabaseFilterAction: (stockDatabaseFilter) => {
            dispatch(settingsActions.setStockDatabaseFilter(stockDatabaseFilter));
        },
        dispatchSetStockTableOrderByAction: (stockTableOrderBy) => {
            dispatch(settingsActions.setStockTableOrderBy(stockTableOrderBy));
        },
        dispatchOpenColorantPackagesConfirmOrderStockModalAction: () => {
            dispatch(navigationActions.openModal(0, componentTypes.COLORANT_PACKAGES_CONFIRM_ORDER_STOCK_MODAL));
        },
        dispatchOpenEditColorantPackageInStockModalAction: (colorantPackageKey) => {
            dispatch(
                navigationActions.openModalWithParams(0, componentTypes.EDIT_COLORANT_PACKAGE_IN_STOCK_MODAL, {
                    colorantPackageKey: colorantPackageKey
                })
            );
        },
        dispatchSaveStockCartAction: (cart) => {
            dispatch(stockActions.saveCart(cart));
        },
        dispatchResetStockCartAction: () => {
            dispatch(stockActions.resetCart());
        }
    };
};

export default StockModal = connect(mapStoreToProps, mapDispatchToProps)(StockModal);
